<div class="component" data-automation-e2e-selector="gamedayContent">
  <div>
    <div
      class="contentWrapper"
      [ngClass]="{ marketDrawerEnabled: marketDrawerEnabled | async }"
    >
      <muni-gameday-progress-bar-chart [loading]="isLoading"> </muni-gameday-progress-bar-chart>
      <muni-gameday-cards-holder></muni-gameday-cards-holder>
    </div>
  </div>
</div>
